export const FETCH_FOLDERS = 'fileActions/FETCH_FOLDERS';
export const FETCH_FOLDERS_SUCCESS = 'fileActions/FETCH_FOLDERS_SUCCESS';
export const FETCH_FOLDERS_FAILED = 'fileActions/FETCH_FOLDERS_FAILURE';

export const CREATE_FOLDER = 'fileActions/CREATE_FOLDER';
export const CREATE_FOLDER_SUCCESS = 'fileActions/CREATE_FOLDER_SUCCESS';
export const CREATE_FOLDER_FAILED = 'fileActions/CREATE_FOLDER_FAILURE';

export const FETCH_FOLDER = 'fileActions/FETCH_FOLDER';
export const FETCH_FOLDER_SUCCESS = 'fileActions/FETCH_FOLDER_SUCCESS';
export const FETCH_FOLDER_FAILED = 'fileActions/FETCH_FOLDER_FAILURE';

export const FETCH_SINGLE_FOLDER = 'fileActions/FETCH_SINGLE_FOLDER';
export const FETCH_SINGLE_FOLDER_SUCCESS =
  'fileActions/FETCH_SINGLE_FOLDER_SUCCESS';
export const FETCH_SINGLE_FOLDER_FAILED =
  'fileActions/FETCH_SINGLE_FOLDER_FAILURE';

export const DELETE_FOLDER = 'fileActions/DELETE_FOLDER';
export const DELETE_FOLDER_SUCCESS = 'fileActions/DELETE_FOLDER_SUCCESS';
export const DELETE_FOLDER_FAILED = 'fileActions/DELETE_FOLDER_FAILURE';

export const UPDATE_FOLDER = 'fileActions/UPDATE_FOLDER';
export const UPDATE_FOLDER_SUCCESS = 'fileActions/UPDATE_FOLDER_SUCCESS';
export const UPDATE_FOLDER_FAILED = 'fileActions/UPDATE_FOLDER_FAILURE';

export const UPDATE_FILE = 'fileActions/UPDATE_FILE';
export const UPDATE_FILE_SUCCESS = 'fileActions/UPDATE_FILE_SUCCESS';
export const UPDATE_FILE_FAILED = 'fileActions/UPDATE_FILE_FAILURE';

export const UPLOAD = 'fileActions/UPLOAD';
export const UPLOAD_SUCCESS = 'fileActions/UPLOAD_SUCCESS';
export const UPLOAD_FAILED = 'fileActions/UPLOAD_FAILURE';

export const ADD_FILE = 'fileActions/ADD_FILE';
export const ADD_FILE_SUCCESS = 'fileActions/ADD_FILE_SUCCESS';
export const ADD_FILE_FAILED = 'fileActions/ADD_FILE_FAILURE';

export const MOVE_FOLDER = 'fileActions/MOVE_FOLDER';
export const MOVE_FOLDER_SUCCESS = 'fileActions/MOVE_FOLDER_SUCCESS';
export const MOVE_FOLDER_FAILED = 'fileActions/MOVE_FOLDER_FAILURE';

export const COPY_FOLDER = 'fileActions/COPY_FOLDER';
export const COPY_FOLDER_SUCCESS = 'fileActions/COPY_FOLDER_SUCCESS';
export const COPY_FOLDER_FAILED = 'fileActions/COPY_FOLDER_FAILURE';

export const FILES_INFO = 'fileActions/FILES_INFO';
export const FILES_INFO_SUCCESS = 'fileActions/FILES_INFO_SUCCESS';
export const FILES_INFO_FAILED = 'fileActions/FILES_INFO_FAILURE';

export const CHANGE_STATE = 'fileActions/CHANGE_STATE';

export function fetchFolders(companyId, filters) {
  return {
    type: FETCH_FOLDERS,
    companyId,
    filters,
  };
}

export function fetchFoldersSuccess(folders, total) {
  return {
    type: FETCH_FOLDERS_SUCCESS,
    folders,
    total,
  };
}

export function fetchFoldersFailed(err) {
  return {
    type: FETCH_FOLDERS_FAILED,
    err,
  };
}

export function createFolder(companyId, details, filters) {
  return {
    type: CREATE_FOLDER,
    details,
    companyId,
    filters,
  };
}

export function changeState() {
  return {
    type: CHANGE_STATE,
  };
}

export function createFolderSuccess(pageFolder) {
  return {
    type: CREATE_FOLDER_SUCCESS,
    pageFolder,
  };
}

export function createFolderFailed(error) {
  return {
    type: CREATE_FOLDER_FAILED,
    error,
  };
}

export function deleteFolder(folderId) {
  return {
    type: DELETE_FOLDER,
    folderId,
  };
}

export function deleteFolderSuccess(folder) {
  return {
    type: DELETE_FOLDER_SUCCESS,
    folder,
  };
}

export function deleteFolderFailed(err) {
  return {
    type: DELETE_FOLDER_FAILED,
    err,
  };
}

export function updateFolder(folderId, details, action) {
  return {
    type: UPDATE_FOLDER,
    folderId,
    details,
    action,
  };
}

export function updateFolderSuccess(folder) {
  return {
    type: UPDATE_FOLDER_SUCCESS,
    folder,
  };
}

export function updateFolderFailed(err) {
  return {
    type: UPDATE_FOLDER_FAILED,
    err,
  };
}

export function fetchFolder(pageId, subdomain) {
  return {
    type: FETCH_FOLDER,
    pageId,
    subdomain,
  };
}

export function fetchFolderSuccess(folder) {
  return {
    type: FETCH_FOLDER_SUCCESS,
    folder,
  };
}

export function fetchFolderFailed(err) {
  return {
    type: FETCH_FOLDER_FAILED,
    err,
  };
}

export function upload(params, file) {
  return {
    type: UPLOAD,
    params,
    file,
  };
}

export function uploadSuccess(file) {
  return {
    type: UPLOAD_SUCCESS,
    file,
  };
}

export function uploadFailed(file) {
  return {
    type: UPLOAD_FAILED,
    file,
  };
}

export function addFile(file, isChatFile) {
  return {
    type: ADD_FILE,
    isChatFile,
    file,
  };
}

export function addFileSuccess(pageFolder) {
  return {
    type: ADD_FILE_SUCCESS,
    pageFolder,
  };
}

export function addFileFailed(error) {
  return {
    type: ADD_FILE_FAILED,
    error,
  };
}

export function updateFile(fileId, details) {
  return {
    type: UPDATE_FILE,
    fileId,
    details,
  };
}

export function updateFileSuccess(folder) {
  return {
    type: UPDATE_FILE_SUCCESS,
    folder,
  };
}

export function updateFileFailed(err) {
  return {
    type: UPDATE_FILE_FAILED,
    err,
  };
}

export function moveFolder(folderId, moveFolderId, categoryType) {
  return {
    type: MOVE_FOLDER,
    folderId,
    moveFolderId,
    categoryType,
  };
}

export function moveFolderSuccess() {
  return {
    type: MOVE_FOLDER_SUCCESS,
  };
}

export function moveFolderFailed(err) {
  return {
    type: MOVE_FOLDER_FAILED,
    err,
  };
}

export function copyFolder(folderId) {
  return {
    type: COPY_FOLDER,
    folderId,
  };
}

export function copyFolderSuccess() {
  return {
    type: COPY_FOLDER_SUCCESS,
  };
}

export function copyFolderFailed(err) {
  return {
    type: COPY_FOLDER_FAILED,
    err,
  };
}

export function filesInfo(companyId) {
  return {
    type: FILES_INFO,
    companyId,
  };
}

export function filesInfoSuccess(info) {
  return {
    type: FILES_INFO_SUCCESS,
    info,
  };
}

export function filesInfoFailed(err) {
  return {
    type: FILES_INFO_FAILED,
    err,
  };
}

export function addUploadedFile(file) {
  return {
    type: ADD_FILE_SUCCESS,
    file,
  };
}
